import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 2),
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5, 2),
    },
  },
  text: {
    color: theme.palette.text.secondary,
    fontSize: "15px",
    lineHeight: 1.5,
    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
}));

export default function SiteFooter() {
  const classes = useStyles();

  return (
    <footer className={classes.root} role="contentinfo">
      <Typography align="center" className={classes.text}>
        © 2026 1000containers Holdings LLC.
      </Typography>
    </footer>
  );
}
